import { useTranslation } from "next-i18next";
import { useGetFormattedErrorAndTitle, useSignInHandler } from "@looksrare/utils";
import { Button, ButtonProps } from "uikit";
import { Watchlist } from "types/graphql";
import { WatchAction } from "utils/graphql/watchlist";
import { useUpdateIsWatchingWatchlist } from "hooks/watchlists";
import { useToast } from "hooks/useToast";
import { ConnectWalletGuard } from "components/Layout/ConnectWalletGuard";

interface WatchWatchlistButtonProps extends ButtonProps {
  isUserWatching: boolean;
  watchlistId: Watchlist["id"];
}
export const WatchWatchlistButton = ({ isUserWatching, watchlistId, ...props }: WatchWatchlistButtonProps) => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const getFormattedErrorAndTitle = useGetFormattedErrorAndTitle();

  const { mutate: updateIsWatchingWatchlist, isPending } = useUpdateIsWatchingWatchlist({
    onSuccess: (newIsWatching: boolean) => {
      toast({
        title: newIsWatching ? t("Watchlist Added") : t("Watchlist Removed"),
      });
    },
    onError: (error) => {
      const { title, description } = getFormattedErrorAndTitle(error);
      toast({ title, description, status: "error", dataIdSuffix: "watch-button-is-watching" });
    },
  });

  const handleWatchUnwatchWatchlist = () => {
    const action: WatchAction = isUserWatching ? "UNWATCH" : "WATCH";
    updateIsWatchingWatchlist({ watchlistId, action });
  };
  const { signInHandler } = useSignInHandler({ onAuthSuccess: handleWatchUnwatchWatchlist });

  return (
    <ConnectWalletGuard size="sm" connectButtonText={t("Watch")}>
      <Button
        size="sm"
        data-id="watchlist-watch-unwatch-button"
        onClick={signInHandler}
        isLoading={isPending}
        {...props}
      >
        {isUserWatching ? t("Unwatch") : t("Watch")}
      </Button>
    </ConnectWalletGuard>
  );
};

WatchWatchlistButton.defaultProps = {
  colorScheme: "primary",
  variant: "fill",
  isUserWatching: false,
};
